import axios from 'axios';
import { BACKEND_URL } from '../config';

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: BACKEND_URL
});

export default axiosInstance;
